const RETRIEVE_EMAIL = '/cdg/epc/v3/email/retrieve';
const RETRIEVE_SMS = '/cdg/epc/v3/sms/retrieve';
const RETRIEVE_TELEMARKETING = '/cdg/epc/v3/telemarketing/retrieve';
const UPDATE_TELEMARKETING = '/cdg/epc/v3/telemarketing/update';
const UPDATE_EMAIL = '/cdg/epc/v3/email/update';
const UPDATE_SMS = '/cdg/epc/v3/sms/update';
const UPDATE_DIRECT_MAIL = '/cdg/epc/v3/mail/update';
const STANDARDIZE_ADDRESS = '/cdg/epc/v3/address/standardize';
const MARKETING_PHONE_RETRIEVE = '/cdg/epc/v3/marketing/phone/retrieve';

export default {
  RETRIEVE_EMAIL,
  RETRIEVE_SMS,
  RETRIEVE_TELEMARKETING,
  UPDATE_DIRECT_MAIL,
  UPDATE_EMAIL,
  UPDATE_SMS,
  UPDATE_TELEMARKETING,
  STANDARDIZE_ADDRESS,
  MARKETING_PHONE_RETRIEVE
};
